import * as React from "react";
import PropTypes from "prop-types";
import userManager from "../oidc/userManager";
import translate from "react-i18next/dist/commonjs/translate";

class UserMenu extends React.Component {
    constructor(props) {
        super(props);
        this.signOut = this.signOut.bind(this);
    }

    changePassword() {
        window.location = `${global.IdpUrl}/account/changepassword`;
    }

    signOut() {
        userManager.signoutRedirect({
            id_token_hint: this.props.signedInUser.id_token
        });
        userManager.clearStaleState();
        localStorage.clear();
    }

  render() {
    const { t } = this.props;
    return (
      <ul
        className={`user-menu-item ${
          this.props.isVisible ? "show-user-menu" : "hide-user-menu"
        }`}
        >
        <li onClick={this.signOut}>
            <a title={t("SignOutButtonTitle")}>
                <i className="fa fa-1 fa-power-off" />
            </a>
        </li>
        <li onClick={this.changePassword}>
            <a title={t("changePassword")}>
                <i className="fa fa-1 fa-cog" />
            </a>
        </li>

      </ul>
    );
  }
}

UserMenu.propTypes = {
  signedInUser: PropTypes.object,
  isVisible: PropTypes.bool.isRequired
};

export default translate("translations")(UserMenu);



// WEBPACK FOOTER //
// ./src/login/UserMenu.js